import { Col, Container, Row } from 'react-bootstrap';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import ContactCard from '../../../../components/ContactCard';
import TextInput from '../../../../components/TextInput';
import Button from '../../../../components/Button';
import FilterPopover from '../../filterPopover';
import { Fragment } from 'react';
import Select from '../../../../components/Select';
import MedicalModal from '../../MedicalModal';
import useModal from '../../../../hooks/useModal';
import DentalModal from '../../DentalModal/DentalModal';
import AdditionalBenefits from '../../AdditionalBenefitsModal';
import IconButtonsStack from '../../../../components/IconButtonsStack';

const threeIconButtons = [
  {
    variant: 'icon-default',
    icon: light('phone'),
    size: 'lg',
    tooltipText: 'Call to 555-555-5555',
  },
  {
    variant: 'icon-default',
    icon: light('globe'),
    size: 'lg',
    tooltipText: 'Open website in new tab',
  },
  {
    variant: 'icon-default',
    icon: light('file-pdf'),
    size: 'lg',
  },
];

const twoIconButtons = [
  {
    variant: 'icon-default',
    icon: light('phone'),
    size: 'lg',
    tooltipText: 'Call to 555-555-5555',
  },
  {
    variant: 'icon-default',
    icon: light('globe'),
    size: 'lg',
    tooltipText: 'Open website in new tab',
  },
];

const contactCards = [
  {
    titleIcon: light('heart-pulse'),
    title: 'Medical',
    img: `${process.env.PUBLIC_URL}/${'cigna.png'}`,
    medicalGroup: 'Cigna HMO',
    status: 'enrolled',
    statusIcon: light('circle-check'),
    contactButtons: <IconButtonsStack iconButtons={threeIconButtons} />,
    modal: true,
  },

  {
    titleIcon: light('tooth'),
    title: 'Dental',
    img: `${process.env.PUBLIC_URL}/${'aetna.png'}`,
    medicalGroup: 'DMO Plan',
    status: 'enrolled',
    statusIcon: light('circle-check'),
    contactButtons: <IconButtonsStack iconButtons={threeIconButtons} />,
    modal: true,
  },

  {
    titleIcon: light('glasses'),
    title: 'Vision',
    img: `${process.env.PUBLIC_URL}/${'vsp.png'}`,
    medicalGroup: 'VSP',
    status: 'enrolled',
    statusIcon: light('circle-check'),
    contactButtons: <IconButtonsStack iconButtons={threeIconButtons} />,
  },

  {
    titleIcon: light('piggy-bank'),
    title: 'Savings & Spending',
    img: `${process.env.PUBLIC_URL}/${'benefit-wallet.png'}`,
    medicalGroup: 'FSA Elected',
    status: 'enrolled',
    statusIcon: light('circle-check'),
    contactButtons: <IconButtonsStack iconButtons={threeIconButtons} />,
  },

  {
    titleIcon: light('baby-carriage'),
    title: 'Life & Accidental Death...',
    img: `${process.env.PUBLIC_URL}/${'met-life.png'}`,
    medicalGroup: 'MetLife',
    status: 'enrolled',
    statusIcon: light('circle-check'),
    contactButtons: <IconButtonsStack iconButtons={twoIconButtons} />,
  },

  {
    titleIcon: light('heart-pulse'),
    title: 'Disability',
    img: `${process.env.PUBLIC_URL}/${'cigna.png'}`,
    medicalGroup: 'CIGNA',
    status: 'enrolled',
    statusIcon: light('circle-check'),
    contactButtons: <IconButtonsStack iconButtons={twoIconButtons} />,
  },

  {
    titleIcon: light('heart-pulse'),
    title: 'Long-Term Disability',
    img: `${process.env.PUBLIC_URL}/${'liberty-mutual.png'}`,
    medicalGroup: 'Liberty Mutual Disability',
    status: 'enrolled',
    statusIcon: light('circle-check'),
    contactButtons: <IconButtonsStack iconButtons={twoIconButtons} />,
  },

  {
    title: 'Additional Benefits',
    modal: true,
  },
];

const resourcesSelectOptions = [
  [
    { label: 'Medical', value: '1' },
    { label: 'Dental', value: '2' },
    { label: 'Vision', value: '3' },
    { label: 'Disability', value: '4' },
    { label: 'Long-Term Diability', value: '5' },
    { label: 'Spousal Surcharge', value: '6' },
    { label: 'Live & Accidental Death', value: '7' },
  ],
  [
    { label: 'Cigna', value: '1' },
    { label: 'MetLife', value: '2' },
    { label: 'Liberty Mutual', value: '3' },
    { label: 'VSP', value: '4' },
  ],
  [
    { label: 'Cigna', value: '1' },
    { label: 'MetLife', value: '2' },
    { label: 'Liberty Mutual', value: '3' },
    { label: 'VSP', value: '4' },
  ],
];

const ResourcesFilter = (
  <Fragment>
    <h6 className={'h6 mb-0 fw-normal'}>{'Filters'}</h6>
    <Select
      placeholder="Benefit Type"
      options={resourcesSelectOptions[0]}
      className={'mt-7'}
    />
    <Select
      placeholder="Title"
      options={resourcesSelectOptions[1]}
      className={'mt-7'}
    />
    <Select
      placeholder="Title"
      options={resourcesSelectOptions[2]}
      className={'mt-7'}
    />
  </Fragment>
);

function Contacts() {
  const [showMedicalModal, handleShowMedicalModal, handleCloseMedicalModal] =
    useModal();

  const [showDentalModal, handleShowDentalModal, handleCloseDentalModal] =
    useModal();

  const [
    showAdditionalBenefitsModal,
    handleShowAdditionalBenefitsModal,
    handleCloseAdditionalBenefitsModal,
  ] = useModal();

  const allModals: (() => void)[] = [];
  allModals[0] = handleShowMedicalModal;
  allModals[1] = handleShowDentalModal;
  allModals[7] = handleShowAdditionalBenefitsModal;

  return (
    <>
      <MedicalModal
        showMedicalModal={showMedicalModal}
        handleCloseMedicalModal={handleCloseMedicalModal}
      />
      <DentalModal
        showDentalModal={showDentalModal}
        handleCloseDentalModal={handleCloseDentalModal}
      />
      <AdditionalBenefits
        showAdditionalBenefitsModal={showAdditionalBenefitsModal}
        handleCloseAdditionalBenefitsModal={handleCloseAdditionalBenefitsModal}
      />
      <Container className={'px-0'}>
        <Container className={'px-0 my-11'}>
          <Row
            className={
              'mx-0 row-cols-lg-3 row-cols-2 d-flex flex-lg-row flex-column-reverse align-items-center'
            }
          >
            <Col className={'px-0 col-lg-6 col-12'}>
              <h6 className={'text-fs-base mb-0 px-0 fw-normal'}>
                See all contact of benefits providers
              </h6>
            </Col>
            <Col className={'px-0 col-lg-6 mb-7 mb-lg-0 col-12'}>
              <Row className={'mx-0'}>
                <Col className={'px-0 col-8'}>
                  <TextInput
                    rightIcon={light('magnifying-glass')}
                    placeholder={'Search plans, benefits, providers'}
                  />
                </Col>
                <Col className={'px-0 col-4'}>
                  <div className={'d-flex justify-content-end'}>
                    <FilterPopover
                      onFilter={() => console.log("I'm filtered")}
                      popoverBody={ResourcesFilter}
                    >
                      <Button leftIcon={light('filter')}>{'Filter'}</Button>
                    </FilterPopover>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>

        <div>
          <Row>
            {contactCards.map((contactCard, idx) => {
              return (
                <Col key={idx} className={'col-12 col-lg-3 mb-7 mb-lg-10'}>
                  <ContactCard
                    title={contactCard.title}
                    titleIcon={contactCard.titleIcon}
                    img={contactCard.img}
                    medicalGroup={contactCard.medicalGroup}
                    status={contactCard.status}
                    statusIcon={contactCard.statusIcon}
                    contactButtons={contactCard.contactButtons}
                    button={
                      contactCard.modal && (
                        <Button
                          className={'col-12 mt-7'}
                          variant="primary"
                          size="lg"
                          onClick={() => allModals[idx]()}
                        >
                          View All
                        </Button>
                      )
                    }
                  />
                </Col>
              );
            })}
          </Row>
        </div>
      </Container>
    </>
  );
}

export default Contacts;
